module.exports = __webpack_public_path__ + "fonts/effect-genetic-recode-evolution-3d3afd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/effect-genetic-recode-evolution.svg
// module id = 760
// module chunks = 0